var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8815 15.3542L11.4161 10.8888C12.4871 9.69313 13.0788 8.144 13.0775 6.53877C13.0775 2.93329 10.1443 0 6.53877 0C2.93329 0 0 2.93329 0 6.53877C0 10.1443 2.93329 13.0775 6.53877 13.0775C8.144 13.0788 9.69313 12.4871 10.8888 11.4161L15.3542 15.8815C15.4998 16.0271 15.7359 16.0271 15.8815 15.8815C16.0271 15.7359 16.0271 15.4998 15.8815 15.3542L15.8815 15.3542ZM0.745682 6.53877C0.745682 3.34445 3.34445 0.745682 6.53877 0.745682C9.73308 0.745682 12.3319 3.34445 12.3319 6.53877C12.3319 9.73308 9.73308 12.3319 6.53877 12.3319C3.34445 12.3319 0.745682 9.73308 0.745682 6.53877Z",
    transform: "translate(0.5 0.5)",
    id: "Shape",
    fill: "#FFFFFF",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.985f5c6c5b8a4eb9e04fc43b9450c9b7.svg";
export { ForwardRef as ReactComponent };